module.exports = __webpack_public_path__ + "img/icon_4.49823c89.png";